import { render, staticRenderFns } from "./change-pos-request-status.vue?vue&type=template&id=55a88a40&scoped=true"
import script from "./change-pos-request-status.vue?vue&type=script&lang=js"
export * from "./change-pos-request-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a88a40",
  null
  
)

export default component.exports